import { memo } from "react";
import { format } from "date-fns";
import { CellContext } from "@tanstack/react-table";
import { fullDateFormatWithTime } from "@common/helpers/date";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { EmptyCell } from "@components/history/views/cells/EmptyCell";
import cellStyles from "@components/history/views/cells/Cell.module.scss";
import { timeAgo } from "@helpers/date";
import { AgentUsageRow } from "../agentUsageRow";

export const LastActivityCell = memo(
    ({ row }: CellContext<ViewTableFeatures, AgentUsageRow, unknown>) => {
        const { lastActivityAt } = row.original;
        if (lastActivityAt === null) {
            return <EmptyCell />;
        }
        const date = new Date(lastActivityAt);
        return (
            <ViewTableCell className={cellStyles.dateCell}>
                <Tooltip content={format(date, fullDateFormatWithTime)}>
                    <span>{timeAgo(date)}</span>
                </Tooltip>
            </ViewTableCell>
        );
    },
);

LastActivityCell.displayName = "LastActivityCell";
